export const GTM_ASSET_KINDS = [
    'positioning-doc', 'webpage-copy', 'overview-slides', 'sales-deck', 'one-pager',
    'pricing-research', 'journey-infographic', 'press-release', 'launch-blog',
    'drip-campaign', 'social-copy', 'social-graphics', 'video-storyboard',
    'battle-cards', 'help-article', 'how-to', 'walkthrough',
];
//# sourceMappingURL=prometheus.js.map